export const ANALYTICS_EVENTS = {
  SIGNUP: 'registrationAccountcreated',
  WEBSITE_VISIT: 'userVisitWebsite',
  USER_SEARCH_PROFILES: 'userSearchProfiles',
  USER_CLICK_MAKE_AN_OFFER: 'userClickMakeAnOffer',
  USER_CLICK_SEND_MESSAGE: 'userClickSendMessage',
  PERFORMER_ADD_TAG: 'performerUseAddTag',
};
